import { render, staticRenderFns } from "./PermissionPicker.vue?vue&type=template&id=6676679c"
import script from "./PermissionPicker.vue?vue&type=script&lang=js"
export * from "./PermissionPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports